export default {
  site: 'bbcgoodfood',
  posts: {
    userRecipe: {
      disclaimer: [{
        type: 'html',
        data: {
          value: 'Member recipes are not tested in the GoodFood kitchen.'
        }
      }]
    }
  },
  header: {
    logo: 'primary',
    eyebrowLogo: 'secondary',
    eyebrowColour: 'dark'
  },
  siteConfig: {
    search: {
      placeholder: 'Ingredient, dish, keyword...'
    }
  },
  tracking: {
    ampGtmId: 'GTM-NZDN3N5',
    ampGtmEnv: 'gtm_auth=uCwWhqzMY7jwQ2Z9e3Cdfw&gtm_preview=env-2'
  },
  myhub: {
    enabled: true,
    title: 'My Good Food',
    collectionInfo: {
      savedItems: {
        empty: {
          title: "You haven't saved any recipes yet…",
          description: "To start collecting your favourites, click the 'Save Recipe' button on any recipe page",
          btnText: 'View recipe hub',
          btnHref: '/recipes'
        }
      },
      collections: {
        empty: {
          title: "You haven't created any collections yet…",
          description: 'Save and sort your favourite recipes into collections so that you can find the perfect dish in no time'
        }
      },
      ownItems: {
        empty: {
          title: "You haven't created any recipes yet…",
          description: 'Got a great recipe? Why not share it with others by publishing it here on bbcgoodfood.com'
        }
      }
    },
    savedRecipes: {
      searchFilter: {
        enabled: true,
        label: 'Search saved recipes',
        collectionInfo: {
          noMatches: {
            title: 'No matches to your filter',
            description: "To start collecting your favourites, click the 'Save Recipe' button on any recipe page",
            btnText: 'View recipe hub',
            btnHref: '/recipes'
          },
          noMatchesOnPage: {
            title: 'No matches to your filter yet…',
            description: 'Load more recipes below'
          }
        }
      }
    }
  },
  enableAmpOnPostType: {
    post: true,
    editorialList: true,
    recipe: true
  }
};